import { keepPreviousData } from "@tanstack/react-query"

import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_EQUIPMENT } from "../../../../../common/constants/modules"

import { equipmentQueryKeys } from "./queryKeys"
import { useEquipmentQuery } from "./useEquipmentQuery"


export function useEquipmentGrades(config = {}, parameters = {}) {
    const url = "equipments/stats/conditions/"

    const queryParameters = useExtendWithSubnetworks(parameters, API_MODULE_EQUIPMENT)
    const queryKey = equipmentQueryKeys["stats_conditions"](queryParameters)

    return useEquipmentQuery(
        url,
        queryKey,
        queryParameters,
        {
            ...config,
            placeholderData: keepPreviousData,
        },
    )
}
